module.exports = __webpack_public_path__ + "img/0Q3B8790-7_H_Foamcore_MockedUp.3767c231.jpg";